//中文繁体
export default {
  Login: {
    Title: "登入您的帳戶",
    describe: "請登入或創建一個帳戶以開始使用。",
    Google: "使用 Google 登入",
    Apple: "使用 Apple 登入",
    or: "或",
    Emailplaceholder: "電子郵件地址",
    Passwordplaceholder: "密碼",
    Login: "登入",
    forgot: "忘記密碼？",
    notAccount: "還沒有 Fineshare 帳戶？",
    Signup: "註冊",
    InvalidEmail: "無效的電子郵件格式。",
    InvalidPassword: "密碼必須至少 6 個字符。",
    loading: "加載中..",
    login: "登入",
    errorText: "登入失敗，請檢查您的帳號和密碼",
  },
  signup: {
    Title: "創建您的帳戶",
    describe: "幾秒鐘內創建您的 Fineshare 帳戶。",
    Google: "使用 Google 註冊",
    Apple: "使用 Apple 註冊",
    or: "或",
    Emailplaceholder: "輸入電子郵件地址",
    Passwordplaceholder: "輸入6位數密碼",
    Already: "已經有帳戶了？",
    Login: "登入",
    By: "創建帳戶即表示我同意我已閱讀並接受",
    Privacy: "隱私政策",
    Terms: "使用條款。",
    and: "和",
    signupText: "創建您的帳戶",
    InvalidEmail: "無效的電子郵件格式。",
    InvalidPassword: "密碼必須至少 6 個字符。",
    loading: "加載中..",
    passwordError: "該電子郵件地址已被註冊",
    again: "您請求過於頻繁，請稍後再試",
    Registration: "註冊失敗，請檢查您的電子郵件和密碼。",
    hasRegistered: "該電子郵件地址已被註冊",
    Title2: "創建您的 Fineshare 帳戶",
  },
  Home: {
    Welcome: "歡迎來到 Fineshare 帳戶中心",
    Hi: "你好，",
    Order: "我的訂單",
    orders: "查看我們的購買訂單",
    Learn: "了解更多",
    Product: "管理產品",
    products: "查看我購買的產品",
    Setting: "帳戶設置",
    Settings: "帳戶詳情並修改密碼",
    account: "充分利用您的帳戶",
    FineCam: "FineCam",
    FineCams: "隨時隨地創建並分享您的靈感視頻",
    FineVoice: "FineVoice",
    FineVoices: "用您最喜歡的聲音創建配音，按照您的方式",
    VoiceTrans: "VoiceTrans",
    VoiceTranss: "轉換您的聲音，傳遞您的情感",
    Singify: "Singify",
    Singifys: "用您喜愛的聲音創建 AI 翻唱",
  },
  success: {
    Congratulations: "恭喜！",
    successfully: "您的 Fineshare 帳戶已成功創建。",
  },
  successapp: {
    Successful: "登錄成功！",
    successfully1: "您已成功登錄到 Fineshare 帳戶，現在可以開始使用應用程式。",
    successfully2:
      "您已成功登錄到 Fineshare 帳戶。您現在可以關閉此窗口並開始使用應用程式。",
    Go: "前往 Fineshare 用戶中心",
  },
  forgot: {
    ForgotPas: "忘記密碼？",
    Enter1: "請輸入重置密碼的郵箱",
    Enter2: "請輸入您的電子郵件地址，我們將發送重置密碼的連結。",
    exmple: "{email}",
    Back: "返回登錄",
    submitText: "提交",
    errorText: "請輸入您的電子郵件地址",
    loading: "加載中...",
    sent: "我們已向您的電子郵件地址發送了一封郵件",
    notExist: "您的電子郵件不存在，請確認您的郵箱",
    Reset: "重置失敗，請確認您的電子郵件",
  },
  account: {
    Settings: "帳戶設定",
    Change: "更改您的帳戶資料、密碼等。",
    Personal: "個人資訊",
    email: "電子郵件：",
    Name: "用戶名：",
    Edit: "編輯",
    title: "更改用戶名",
    message: "輸入的名稱不能為空。",
    placeholder: "請輸入用戶名",
    Reset: "重置密碼",
    Resets: "您可以重置密碼，請輸入6位或更多數字和密碼",
    ResetPas: "重置密碼",
    Delete: "刪除帳戶",
    Deletes: "這將永久刪除您的帳戶及所有數據，您將無法重新啟用此帳戶。",
    sure: "您確定要刪除您的 Fineshare 帳戶嗎？",
    sures:
      "一旦您的帳戶被刪除，所有您的 Fineshare 數據將永久刪除。為了繼續刪除帳戶，我們已向您發送驗證碼。請輸入驗證碼並點擊確認。",
    Deletebtn: "刪除",
    Deleteplaceholder: "請輸入6位驗證碼",
  },
  order: {
    Order: "我的訂單",
    history: "您的訂單歷史已記錄在此頁面",
    dont: "您還沒有產品",
    Buy: "立即購買以獲得更多優化，點擊下面的按鈕立即購買",
    BuyBtn: "立即購買",
    OrderId: "訂單編號：",
    Price: "價格：",
    Date: "訂單日期：",
  },
  Product: {
    Product: "我的產品",
    products: "您登入帳戶中的產品",
    dont: "您還沒有產品",
    Management: "管理設備 >",
  },
  redeem: {
    Redeem: "兌換會員",
    products: "在這裡您可以兌換 Fineshare 產品",
    Please: "請輸入您的兌換碼",
    placeholder: "兌換碼",
    Submit: "提交",
    Notes: "備註：",
    Notes1: "1.兌換碼格式：XXXXX；",
    Notes2: "2.要查看您的兌換產品，請點擊“產品”菜單。",
    Successfully: "兌換成功",
    Follow: "按照以下步驟開始使用 VoiceTrans：",
    step1: "1. 下載並安裝 Fineshare VoiceTrans。",
    step2: "2. 打開 VoiceTrans 並進入 ",
    Account: "帳戶",
    step3: "3. 輸入您的電子郵件和密碼登錄您的 Fineshare 帳戶。",
    Tips: "提示：為了更好的使用，請閱讀 ",
    guide: "指南",
    Redemption: "兌換失敗",
    redeemed: "該兌換碼已經被使用，請打開軟體並重新登錄您的帳戶以開始使用。",
    Failed: "兌換失敗",
    check: "請檢查您的兌換碼。",
  },
  details: {
    Product: "我的產品",
    products: "您購買的所有產品都在此頁面",
    Back: "返回列表",
    Name: "設備名稱",
    system: "設備系統",
    status: "設備狀態",
    Operation: "操作",
    Delete: "刪除",
    contact: "目前不支持直接移除設備，如需移除設備，請通過以下方式聯繫我們：",
  },
  nav: {
    Home: "首頁",
    Account: "帳戶",
    Order: "訂單",
    Product: "產品",
    Redeem: "兌換",
    Help: "幫助中心",
  },
  auth: {
    Authorization: "授權成功！",
    wait: "正在返回應用程式，請稍候...",
  },
  notfound: {
    Not: "頁面未找到",
    Unfortunately: "很抱歉，您所尋找的頁面不存在，或者您輸入的鏈接有誤。",
    Home: "返回首頁",
  },
  topuser: {
    Settings: "帳戶設置",
    language: "語言",
    Logout: "登出",
  },
  loginweb: {
    Conversion: "轉換即將開始",
    currently: "當前排隊人數為 ",
    people: "人！",
    Please: "請登錄，我們將在轉換完成後將結果發送到您的電子郵件。",
    dont: "我不想登錄",
  },
  mobilelogin: {
    Welcome: "歡迎使用 Fineshare！請登錄以開始使用。",
  },
  reset: {
    Reset: "重置新密碼",
    Password: "密碼要求至少6個字符，並包含至少1個字母和1個數字。",
    password: "請輸入您的新密碼",
    Back: "返回登錄",
    Congratulations: "恭喜！",
    successfully: "密碼重置成功，立即開始登錄",
    Login: "登錄",
    Please: "請輸入6個數字和字母",
    failed: "密碼重置失敗，請點擊郵件中的重置鏈接",
  },
  verification: {
    verification: "請輸入驗證碼",
    haveverification: "我們已發送驗證碼到 ",
    Please: "。請在下方輸入您收到的驗證碼：",
    Enter: "請輸入6位驗證碼",
    Resend: "重新發送驗證碼",
    Wait: "等待 ",
    again: " 秒後重新發送",
    Verify: "驗證",
    error: "驗證碼錯誤",
    verificationcode: "請輸入驗證碼",
  },
};
